import type {DigitalAssetTransferInvitationWDto} from '@cohort/wallet-schemas/ownership';
import {createContext} from 'react';

const TransferInvitationContext = createContext<DigitalAssetTransferInvitationWDto | null>(null);

export default TransferInvitationContext;
